import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly LANGUAGE_KEY = 'userLanguage';
  public language: WritableSignal<string>;

  constructor() {
    const storedLang = this.getStoredLanguage();
    const browserLang = this.getBrowserLanguage();
    const lang = storedLang || browserLang || 'en';
    this.language = signal(lang);
  }

  private getStoredLanguage(): string | null {
    return localStorage.getItem(this.LANGUAGE_KEY);
  }

  private storeLanguage(lang: string): void {
    localStorage.setItem(this.LANGUAGE_KEY, lang);
  }

  private getBrowserLanguage(): string {
    return navigator.language.split('-')[0];
  }

  public setLanguage(lang: string): void {
    this.language.set(lang);
    this.storeLanguage(lang);
  }

  public getCurrentLanguage(): string {
    return this.language();
  }
}
